import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { ServiceRecordRow, ServiceRecordInput, ServiceRecord } from './service-record.model'
import { ApiService } from '@shared/services/api.service'
import { toFormData } from '@core/helpers/to-form-data'
import { withFeedback } from '@app/core/interceptors/feedback-context'
@Injectable({ providedIn: 'root' })
export class ServiceRecordService {
  constructor(private apiService: ApiService) {}

  getList(
    reminderId: number,
    pageIndex = 0,
    pageSize = 10,
    sort?: string,
    filterValues?: { [param: string]: string | number | (string | number)[] },
    fields?: (keyof ServiceRecordRow)[],
  ) {
    const toServiceRecordRow = (record: ServiceRecordRow) => new ServiceRecordRow(record)
    return (
      this.apiService
        .getPageable<ServiceRecordRow>(`/reminders/${reminderId}/service-records`, pageIndex, pageSize, sort, filterValues, fields)
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        .pipe(map(({ data, ...rest }) => ({ data: data.map(toServiceRecordRow), ...rest })))
    )
  }

  create(reminderId: number, data: ServiceRecordInput): Observable<ServiceRecord> {
    return this.apiService.post(`/reminders/${reminderId}/service-records/`, toFormData(data), { context: withFeedback() })
  }

  edit(reminderId: number, recordId: number, record: ServiceRecord): Observable<ServiceRecord> {
    return this.apiService.post(`/reminders/${reminderId}/service-records/${recordId}`, toFormData(record), { context: withFeedback() })
  }

  delete(reminderId: number, recordId: number): Observable<void> {
    return this.apiService.delete(`/reminders/${reminderId}/service-records/${recordId}`, { context: withFeedback() })
  }
}
